import { IInviteStatus } from '@cincel/client';

export function signersOfFileByStage(signers) {
  const stages: any = [];
  let userAux: any;
  let auxStage = 1;
  signers.forEach((signer) => {
    if (!signer.stage) {
      auxStage = Math.floor(Math.random() * 2) + 1;
    }
    userAux = {
      ...signer,
      idInvitation: signer.uuid,
      has_sign:
        signer && signer.status && signer.status == IInviteStatus.COMPLETED
          ? true
          : false,
      email: signer.email || signer.user.email,
      name: signer.name || signer.user.name,
      stage: signer.stage ? signer.stage : auxStage,
      status: signer.status,
      signature_allowed_types: signer.signature_allowed_types,
    };
    if (stages[userAux.stage - 1]) {
      stages[userAux.stage - 1].push(userAux);
    } else {
      stages[userAux.stage - 1] = [userAux];
    }
  });
  return stages;
}
